
import ScoreContainer from '@/assets/images/load.png'
import ScoreSeparator from '@/assets/images/score-separator.png'

export default {
    name: "score",
    props:{
        opponent: {
            type: String,
            default: ''
        },
        nickname: {
            type: String,
            default: ''
        },
        score:{
            type: Object,
            default: {}
        },
        currentRound:{
            default: 0
        }
    },
    components: {
    },
    data: () => {
        return {
            visible: true,
            scoreContainer: ScoreContainer,
            scoreSeparator: ScoreSeparator,
            actualRound: 0
        }
    },
    watch: {
        currentRound(val) {
            setTimeout(() => {
                this.actualRound = val
            }, 1500)
        }
    },

    mounted() {

    },

    beforeDestroy() {

    },

    methods: {
        restart(){
            
        },
        splitNames (text, delay) {
            let t = text.split(" ")
            let out = ""
            let tmp = 0
            t.forEach(l => {
                out += ' <span class="word"> '
                let w = l.split("")
                w.forEach(c => {
                    if (delay) {
                        out += '<span style=" transition-delay:' + tmp * .015 + 's" class="letter">'
                        out += c
                        out += '</span>'
                        tmp++
                    } else {
                        out += '<span class="letter">'
                        out += c
                        out += '</span>'
                        tmp++
                    }
                })
                out += '</span>'
            })
            return out
        }
    }
}
